import axios from '../axios'
import Qs from 'qs'
/**
 * 注册
 * @param {*} data
 */
 export const agencyInfoRegister = data => {
  return axios({
    url: '/agency/agencyInfo/register',
    method: 'post',
    data,
    headers: {
      isToken: false
    }
  })
}
/**
 * 修改机构级别信息
 * @param {*} data
 */
 export const agencyInfoUpdate = data => {
  return axios({
    url: '/agency/agencyInfo/update',
    method: 'post',
    data
  })
}
/**
 * 登录
 * @param {*} data
 */
 export const oauthToken = data => {
  return axios({
    url: '/auth/oauth/token',
    method: 'post',
    data: Qs.stringify(data),
    headers: {
      isToken: false,
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

/**
 * 发送重置密码的验证码
 * @param {*} data
 */
 export const forgotPwdSms = data => {
  return axios({
    url: '/auth/forgot_pwd_sms',
    method: 'post',
    data: Qs.stringify(data),
    headers: {
      isToken: false,
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

/**
 * 重置密码
 * @param {*} data
 */
 export const forgotPwd = data => {
  return axios({
    url: '/auth/forgot_pwd',
    method: 'post',
    data: Qs.stringify(data),
    headers: {
      isToken: false,
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

/**
 * 机构列表信息
 * @param {*} data
 */
 export const agencyList = data => {
  return axios({
    url: '/club/clubAccount/agencyList',
    method: 'get'
  })
}

/**
 * 退出登录
 * @param {*} data
 */
 export const oauthLogout = data => {
  return axios({
    url: '/auth/oauth/logout',
    method: 'post'
  })
}

/**
 * 机构账户列表
 * @param {*} data
 */
 export const clubList = data => {
  return axios({
    url: '/club/clubAccount/clubList/' + data.agencyId,
    method: 'get'
  })
}

/**
 * 查询授权的账户
 * @param {*} data
 */
 export const agencyby = data => {
  return axios({
    url: '/auth/sysAccount/agency/by/' + data.agencyId + '/' + data.account,
    method: 'get'
  })
}

/**
 * 添加账户
 * @param {*} data
 */
 export const clubAccountAdd = data => {
  return axios({
    url: '/club/clubAccount/add/' + data.agencyId + '/' + data.accountId,
    method: 'get'
  })
}

/**
 * 添加授权账户
 * @param {*} data
 */
 export const accountRegister = data => {
  return axios({
    url: '/auth/agency/register',
    method: 'put',
    data
  })
}

/**
 * 删除账户
 * @param {*} data
 */
 export const clubAccountDelete = data => {
  return axios({
    url: '/club/clubAccount/delete/' + data.agencyId + '/' + data.accountId,
    method: 'delete'
  })
}

/**
 * 授权
 * @param {*} data
 */
 export const authRole = data => {
  return axios({
    url: '/auth/sysAccount/auth_role/' + data.sysId + '/' + data.agencyId + '/' + data.userId,
    method: 'put',
    data: data.roleIds
  })
}

// 获取自身角色列表
export const findUserRoleList = data => {
  return axios({
    url: '/auth/sysRole/agency/by_user/' + data.sysId + '/' + data.agencyId,
    method: 'post',
    data: Qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 获取自己创建角色列表
export const findRoleList = data => {
  return axios({
    url: '/auth/sysRole/agency/list/' + data.sysId + '/' + data.agencyId,
    method: 'post',
    data: Qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 添加角色
export const findRoleAdd = data => {
  return axios({
    url: '/auth/sysRole/agency/add',
    method: 'put',
    data
  })
}

// 查询角色数据
export const findRoleby = data => {
  return axios({
    url: '/auth/sysRole/agency/by/' + data.sysId + '/' + data.agencyId + '/' + data.roleId,
    method: 'get'
  })
}

// 修改角色
export const findRoleUpdate = data => {
  return axios({
    url: '/auth/sysRole/agency/update',
    method: 'put',
    data
  })
}

// 删除角色
export const findRoleRemove = data => {
  return axios({
    url: '/auth/sysRole/agency/remove/' + data.sysId + '/' + data.agencyId,
    method: 'delete',
    data: [data.roleId]
  })
}

// 删除角色
export const agencyRoleUsable = data => {
  return axios({
    url: '/auth/sysRole/agency/usable/' + data.agencyId,
    method: 'post',
    data: Qs.stringify({
      roleId: data.roleId,
      usable: data.usable
    }),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}







// WEBPACK FOOTER //
// ./src/http/modules/user.js